export default  {
    apptitle: "CoKart Parnter App",
    services: {
        netcoverage: {
            title: "Netzabdeckung",
            lte2600: "LTE 2600 Netzabdeckung",
            lte1800: "LTE 1800 Netzabdeckung",
            lte800: "LTE 800 Netzabdeckung",
            hsdpa: "HSDPA Netzabdeckung",
            edge: "Edge Netzabdeckung ",
            gsm: "GSM & GPRS Netzabdeckung",
            lteextension: "LTE Netzausbau"
        }
    },
    map: {
        ui: {
            nodeUpdateError: {
                info: "Leider werden die Daten gerade nicht \xFCbertragen. Bitte die Karte in wenigen Minuten neu starten."
            }
        }
    },
    omnisearch: {
        ui: {
            error: "Leider funktioniert die Abfrage gerade nicht. Bitte in wenigen Minuten nochmal versuchen.",
            esriGeocoder: {
                title: "Esri Geocoooding",
                description: "Adressen und Orte finden.",
                omniSearchDefaultLabel: "Adresse oder Ort finden..."
            }
        }
    },
    navigationtoolset: {
        ui: {
            zoomInClickTool: {
                title: "Vergr\xF6\xDFern",
                tooltip: "Vergr\xF6\xDFern"
            },
            zoomOutClickTool: {
                title: "Verkleinern",
                tooltip: "Verkleinern"
            }
        }
    },
    vf_notifier: {
        ui: {
            title: "Notifier",
            tooltips: {
                close: "Close this message",
                glue: "Pin this message"
            }
        }
    },
    vf_legend: {
        ui: {
            legendHeader: "Legende",
            simple: {
                gen4: {
                    label: "4G",
                    info: "(LTE)",
                    video: "suitability points-5",
                    audio: "suitability points-5",
                    internet: "suitability points-5",
                    mail: "suitability points-5",
                    maxDownloadSpeed: "3MB: 0,1 Sek.",
                    maxSpeed: "500 Mbit/s"
                },
                gen2: {
                    label: "2G",
                    info: "(GSM/EDGE)",
                    video: "suitability points-0",
                    audio: "suitability points-0",
                    internet: "suitability points-1",
                    mail: "suitability points-1",
                    maxDownloadSpeed: "3MB: 2-3 Min.",
                    maxSpeed: "220 kbit/s"
                },
                extension: {
                    label: "Netzausbau",
                    info: "(n\xE4chste 4 Wochen)"
                }
            },
            partner: {
                gen42600: {
                    label: "4G",
                    info: "(LTE 2600)"
                },
                gen41800: {
                    label: "4G",
                    info: "(LTE 1800)"
                },
                gen4800: {
                    label: "4G",
                    info: "(LTE 800)"
                },
                gen2edge: {
                    label: "2G",
                    info: "(EDGE)"
                },
                gen2gsm: {
                    label: "2G",
                    info: "(GSM)"
                }
            },
            fixnet: {
                cbl: {
                    label: "Kabel",
                    info: "bis 100 Mbit/s",
                    point1: {
                        label: "Kabel 100",
                        info: "Downstream bis zu 100.000 kbit/s"
                    },
                    point2: {
                        label: "Kabel 50",
                        info: "Downstream bis zu 50.000 kbit/s"
                    },
                    point3: {
                        label: "Kabel 25",
                        info: "Downstream bis zu 25.000 kbit/s"
                    },
                    point4: {
                        label: "Kabel 10",
                        info: "Downstream bis zu 10.000 kbit/s"
                    }
                },
                vdsl: {
                    label: "DSL",
                    info: "bis 50 Mbit/s",
                    point1: {
                        label: "VDSL 50000",
                        info: "Downstream 27.900 - 50.000 kbit/s"
                    },
                    point2: {
                        label: "VDSL 25000",
                        info: "Downstream 16.700 - 25.000 kbit/s"
                    }
                },
                adsl: {
                    label: "DSL",
                    info: "bis 16 Mbit/s",
                    point1: {
                        label: "DSL 16000",
                        info: "Downstream 6.145 - 16.000 kbit/s"
                    },
                    point2: {
                        label: "DSL 6000",
                        info: "Downstream 2.049 - 6.016 kbit/s"
                    }
                },
                dslInfoLabel: "Die Maximal-Geschwindigkeit h\xE4ngt von der gebuchten DSL-Bandbreite ab.",
                cblInfoLabel: "Die Maximal-Geschwindigkeit h\xE4ngt von dem gebuchten Kabel-Paket ab."
            },
            expert: {
                vdsl: {
                    label: "VDSL",
                    info: ""
                },
                adsl: {
                    label: "DSL",
                    info: ""
                },
                gen42600: {
                    label: "4G",
                    info: "(LTE 2600)",
                    video: "suitability points-5",
                    audio: "suitability points-5",
                    internet: "suitability points-5",
                    mail: "suitability points-5",
                    maxDownloadSpeed: "3MB: 3 Sek.",
                    maxSpeed: "100 Mbit/s"
                },
                gen41800: {
                    label: "4G",
                    info: "(LTE 1800)",
                    video: "suitability points-5",
                    audio: "suitability points-5",
                    internet: "suitability points-5",
                    mail: "suitability points-5",
                    maxDownloadSpeed: "3MB: 3 Sek.",
                    maxSpeed: "100 Mbit/s"
                },
                gen4800: {
                    label: "4G",
                    info: "(LTE 800)",
                    video: "suitability points-5",
                    audio: "suitability points-5",
                    internet: "suitability points-5",
                    mail: "suitability points-5",
                    maxDownloadSpeed: "3MB: 6 Sek.",
                    maxSpeed: "50 Mbit/s"
                },
                gen3hsdpa: {
                    label: "3G",
                    info: "(HSDPA)",
                    video: "suitability points-3",
                    audio: "suitability points-4",
                    internet: "suitability points-4",
                    mail: "suitability points-5",
                    maxDownloadSpeed: "3MB: 7 Sek.",
                    maxSpeed: "42,4 Mbit/s"
                },
                gen2edge: {
                    label: "2G",
                    info: "(EDGE)",
                    video: "suitability points-0",
                    audio: "suitability points-0",
                    internet: "suitability points-1",
                    mail: "suitability points-1",
                    maxDownloadSpeed: "3MB: 2-3 Min.",
                    maxSpeed: "220 kbit/s"
                },
                gen2gsm: {
                    label: "2G",
                    info: "(GSM)",
                    video: "suitability points-0",
                    audio: "suitability points-0",
                    internet: "suitability points-0",
                    mail: "suitability points-1",
                    maxDownloadSpeed: "56 kbit/s",
                    maxSpeed: "3MB: 7-8 Min."
                }
            },
            maximumspeed: "Maximal-Geschwindigkeit",
            mbitSec: "Mbit/s",
            kbitSec: "kbit/s",
            infoLabel: "Abh\xE4ngig vom genutzten Ger\xE4t ist die Durchschnittsgeschwindigkeit geeignet f\xFCr:",
            video: "Video-Streams",
            audio: "Audio-Streams",
            internet: "Internet-Surfen",
            mail: "E-Mails (nur Text)",
            maxDownload: "Max. Download-Speed",
            sec: "Sek.",
            min: "Min.",
            extensionLabel: "Hier wird unser 3G- und 4G-Netz in den kommenden Wochen ausgebaut. Die Darstellung bezieht sich auf Plandaten.",
            indoorRadioTooltip: "Darstellung der Versorgung innerhalb von Geb\xE4uden.",
            outdoorRadioTooltip: "Darstellung der Versorgung im Freien."
        }
    },
    vf_adress_search: {
        ui: {
            windowTitle: "Adress-Suche",
            resultTitle: "Bandbreite vor Ort",
            omnisearchLabel: "Adresse eingeben",
            requestAddress: "PLZ Ort Stra\xDFe",
            requestNumber: "Nr.",
            invalidNumber: "Bitte geben Sie eine korrekte Hausnummer ein.",
            searchAddress: "Adresse suchen",
            checkAddress: "Adresse pr\xFCfen",
            mbitSec: "Mbit/s",
            kbitSec: "kbit/s",
            resultHeader: "Bandbreite vor Ort",
            utilization: "Auslastung",
            low: "gering",
            lowTooltip: "Bei geringer Auslastung erreicht man die gr\xF6\xDFtm\xF6gliche Bandbreite. Beispiel: Man startet nachts als einziger einen Download.",
            medium: "mittel",
            mediumTooltip: "Bei mittlerer Auslastung erreicht man auch eine mittlere Bandbreite. Beispiel: Mehrere Leute in der N\xE4he rufen ihre E-Mails ab oder surfen im Internet.",
            high: "hoch",
            highTooltip: "Bei hoher Auslastung erreicht man eher die untere Bandbreite. Beispiel: Viele Leute in der N\xE4he sehen sich YouTube-Videos an.",
            gen4: "4G",
            nogen4: "Aktuell liegt uns leider keine 4G-Bandbreite vor.",
            gen2: "Momentan gibt es an dieser Adresse nur eine 2G-Abdeckung.",
            nogen2: "Leider gibt es momentan an dieser Adresse keine Netzabdeckung.",
            usageInfo: "Infos zur Auslastung",
            calculationTooltip: {
                title: "Die Bandbreiten in der Tabelle sind berechnete Werte.",
                point1: "Saisonale Besonderheiten, z.B. Feiertage oder Gro\xDFveranstaltungen, werden nicht ber\xFCcksichtigt.",
                point2: "Die Werte zeigen die voraussichtlichen Bandbreiten im Freien am gew\xE4hltem Standort.",
                point3: "Die Bandbreite, die tats\xE4chlich genutzt werden kann, h\xE4ngt von weiteren Faktoren ab. Z.B. von der Technologie des verwendeten Ger\xE4ts oder der Platzierung im Haus."
            },
            extension: "Netzausbau",
            extensionInfo: "An diesem Standort bauen wir bald unser {technology} Netz aus.",
            extensions: {
                gen2: "2G",
                lte800: "4G (LTE 800)",
                lte1800: "4G (LTE 1800)",
                lte2600: "4G (LTE 2600)"
            },
            homeAreaCheck: "Zuhause-Bereich anzeigen",
            homeAreaTooltip: "Darstellung des Vodafone-Zuhause-Bereichs f\xFCr die eingegebene Adresse",
            lteDirection: "Richtung der n\xE4chsten LTE-Antenne: {direction}\xB0 {label}",
            lteDistance: "Distanz zur n\xE4chsten LTE Antenne: {distance} m",
            northing: {
                n: "(Nord)",
                ne: "(Nordost)",
                e: "(Ost)",
                se: "(S\xFCdost)",
                s: "(S\xFCd)",
                sw: "(S\xFCdwest)",
                w: "(West)",
                nw: "(Nordwest)"
            },
            //    relevanceLevelMissmatch: "Die Suche ergab nur ungenaue Treffer. ",
            //    houseNumberMissmatch: "Die genaue Lage der Adresse ist unbekannt. Die Verf\u00fcgbarkeitspr\u00fcfung erfolgt auf Straßenebene.",
            houseNumberNotExistent: "Die Hausnummer '{number}' wurde nicht gefunden. Wir geben daher die verf\xFCgbare Bandbreite f\xFCr die Adresse '{address}' an.",
            noPreciseResultFoundMessage: "F\xFCr  genauere Ergebnisse bitte eine vollst\xE4ndige Adresse mit Ort, Stra\xDFe und Hausnummer angeben.",
            tool: {
                tooltip: "Standort in Karte w\xE4hlen"
            },
            base: {
                title: "Bandbreite vor Ort"
            },
            coverage: {
                gen4: "4G",
                gen2: "2G",
                lte2600info: "(LTE 2600)",
                lte800info: "(LTE 800)",
                hsdpainfo: "(HSDPA)",
                edgeinfo: "(EDGE)",
                gsminfo: "(GSM)",
                outdoor: "drau\xDFen",
                indoor: "drinnen"
            },
            partner: {
                title: "Bandbreite und Technologien vor Ort"
            },
            expert: {
                title: "Mobilfunk-Technologien am gew\xE4hlten Standort"
            },
            fixnet: {
                title: "Festnetztechnologien am Standort",
                kabel: "Kabel",
                dsl: "DSL",
                dsl100Info: "bis zu 100 Mbit/s",
                dsl50Info: "bis zu 50 Mbit/s",
                dsl16Info: "bis zu 16 Mbit/s",
                tooltip: "Die Darstellung gibt nur Hinweise auf die Verf\xFCgbarkeit in der Region. Welche Produkte an der gew\xE4hlten Adresse genau buchbar sind, erf\xE4hrt man z.B. unter vodafone.de/dsl oder im Vodafone-Shop."
            }
        },
        error: {
            messageCheckCoverageFailed: "Leider funktioniert die Abfrage gerade nicht. Bitte in wenigen Minuten nochmal versuchen.",
            messageAutocompletionFailed: "Leider funktioniert die Abfrage gerade nicht. Bitte in wenigen Minuten nochmal versuchen.",
            messageGeocodingFailed: "Leider funktioniert die Abfrage gerade nicht. Bitte in wenigen Minuten nochmal versuchen.",
            messageRadiusRequestFailed: "Leider funktioniert die Abfrage gerade nicht. Bitte in wenigen Minuten nochmal versuchen.",
            messageRadiusNotAvailable: "Der Zuhause-Bereich kann f\xFC diese Adresse leider nicht angezeigt werden."
        }
    },
    vf_info_window: {
        ui: {
            mobileRadio: {
                popup_verified: {
                    popup_verified_url: ""
                }
            }
        }
    }
};
